module.exports = __webpack_public_path__ + "static/media/money-bill-wave-solid.24937b81.svg";